import request from '@/utils/request'

// 文件上传接口
export function uploadFile(data) {
  return request({
    url: '/resource/oss/upload',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}


// 文件上传接口
export function uploadFileH5(data) {
  return request({
    url: '/resource/oss/uploadH5',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 根据OSS文件ID列表查询文件信息
export function listOssByIds(ossIds) {
  const ids = Array.isArray(ossIds) ? ossIds.join(',') : ossIds
  return request({
    url: `/resource/oss/listByIds/${ids}`,
    method: 'get'
  })
}